import type {OptionFilterItem} from '@/modules/common/models/filters';

import {sortBy} from 'lodash';

import {
  FILTER_BOARD_TYPE,
  FILTER_ROOM_ATTRIBUTES,
  FILTER_ROOM_TYPE,
} from '@/modules/common/models/filters';

const customOrder: Record<string, Array<string>> = {
  [FILTER_ROOM_TYPE]: [
    'IT04-DO',
    'IT04-SUI',
    'IT04-FA',
    'IT04-ST',
    'IT04-BU',
    'IT04-SI',
    'IT04-MB',
    'IT04-DU',
    'IT04-AP',
    'IT04-HF',
    'IT04-HO',
    'IT04-VI',
    'IT04-XX',
  ],
  [FILTER_BOARD_TYPE]: [
    'IT06-AI',
    'IT06-FB',
    'IT06-HB',
    'IT06-BB',
    'IT06-NB',
    'IT06-XX',
  ],
  [FILTER_ROOM_ATTRIBUTES]: [
    'IT13-SEVI',
    'IT05-BT',
    'IT05-PO#SUP',
    'IT05-PO#PP',
    'IT05-PO',
    'IT05-WP#PW',
    'IT05-WP',
  ],
};

export const customFilterSorting = (
  options: Array<OptionFilterItem>,
  keyword: string
): Array<OptionFilterItem> => {
  if (customOrder[keyword]) {
    const order = customOrder[keyword];
    return sortBy(options, (option) => {
      const index = order.indexOf(option.value);
      return index === -1 ? Infinity : index;
    });
  }
  return sortBy(options, (option) => option.label.toLowerCase());
};
